module.exports = __webpack_public_path__ + "static/feature6-32f0f4b956575c10862604f3a28ff5cc.png";